import {
  invokeServiceWorkerUpdateFlow,
  updateServiceWorker,
  restoreUpdateAfterReload,
} from "./services/skipWatting";

const swDev = async () => {

  const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

  if ('serviceWorker' in navigator) {

    console.log('register serviceWorker');

    const registration =
      await navigator.serviceWorker.register(swUrl)
        .catch(error => {
          console.error(
            'Service worker registration failed:',
            error
          );
        });

    if (!registration) {
      return;
    }


    // ==================================================
    // لو حصل تحديث بالفعل ثم عملنا reload
    // نحافظ على حالة زر التحديث لمدة 10 ثوانٍ
    // ==================================================

    restoreUpdateAfterReload();


    // ==================================================
    // يوجد SW جديد بالفعل في waiting
    // ==================================================

    if (registration.waiting) {

      invokeServiceWorkerUpdateFlow(
        registration
      );

    } else {

      // لا يوجد تحديث منتظر
      localStorage.setItem(
        'updateServiceWorker',
        false
      );
    }


    // ==================================================
    // متابعة Service Worker
    // ==================================================

    updateServiceWorker(
      registration,
      true
    );
  }
};

export default swDev;